// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "categories-landing-" + (chunkId === 226 ? "webfooter-Footer" : chunkId) + "-st-" + {"221":"1e49eb55","226":"68ae75ee","257":"de387247","435":"33c2882b","473":"8a1aea91","838":"0154dfe9","846":"a8e9efbe"}[chunkId] + ".js";
};